import { socialCrawlerApiClient } from '../client';

export function getUrlsData() {
  return socialCrawlerApiClient.get('/dashboard').then(({ data }) => data);
}

export function getLocationsSources() {
  return socialCrawlerApiClient
    .get('/location/sources')
    .then(({ data }) => data);
}

export function getProvidersSources() {
  return socialCrawlerApiClient
    .get('/provider/sources')
    .then(({ data }) => data);
}
